export enum MOTIVATION_VALUES {
  DID_NOT_HAVE_EXPECTED_SUCCESS = 'DID_NOT_HAVE_EXPECTED_SUCCESS',
  DID_NOT_MEET_INITIAL_EXPECTATION = 'DID_NOT_MEET_INITIAL_EXPECTATION',
  MADE_MISTAKE_SETTING_UP = 'MADE_MISTAKE_SETTING_UP',
  CREATE_JUST_FOR_TESTING = 'CREATE_JUST_FOR_TESTING',
  CREATED_MANY_COMMUNITIES_AND_DECIDED_TO_SIMPLIFY = 'CREATED_MANY_COMMUNITIES_AND_DECIDED_TO_SIMPLIFY',
  ANOTHER_MOTIVE = 'ANOTHER_MOTIVE'
}

export const MOTIVATION_QUESTION_DATAHUB_LABEL = 'Qual é o motivo da remoção?'

export const MOTIVATION_ANSWER_DATAHUB_VALUES = {
  [MOTIVATION_VALUES.DID_NOT_HAVE_EXPECTED_SUCCESS]: {
    label: 'Não obtive o sucesso esperado na comunidade.',
    index: 0
  },
  [MOTIVATION_VALUES.DID_NOT_MEET_INITIAL_EXPECTATION]: {
    label: 'A comunidade não atendeu às minhas expectativas iniciais.',
    index: 1
  },
  [MOTIVATION_VALUES.MADE_MISTAKE_SETTING_UP]: {
    label:
      'Errei na configuração da comunidade (por exemplo, queria uma comunidade aberta e criei uma exclusiva).',
    index: 2
  },
  [MOTIVATION_VALUES.CREATE_JUST_FOR_TESTING]: {
    label: 'Criei a comunidade apenas para teste.',
    index: 3
  },
  [MOTIVATION_VALUES.CREATED_MANY_COMMUNITIES_AND_DECIDED_TO_SIMPLIFY]: {
    label: 'Criei muitas comunidades e decidi simplificar.',
    index: 4
  },
  [MOTIVATION_VALUES.ANOTHER_MOTIVE]: {
    label: 'Outro motivo. Qual?',
    index: 5
  }
}

export const MOTIVATION_OPTIONS = [
  {
    value: MOTIVATION_VALUES.DID_NOT_HAVE_EXPECTED_SUCCESS,
    label: 'community_survey.delete_community.motivation.option_1'
  },
  {
    value: MOTIVATION_VALUES.DID_NOT_MEET_INITIAL_EXPECTATION,
    label: 'community_survey.delete_community.motivation.option_2'
  },
  {
    value: MOTIVATION_VALUES.MADE_MISTAKE_SETTING_UP,
    label: 'community_survey.delete_community.motivation.option_3'
  },
  {
    value: MOTIVATION_VALUES.CREATE_JUST_FOR_TESTING,
    label: 'community_survey.delete_community.motivation.option_4'
  },
  {
    value: MOTIVATION_VALUES.CREATED_MANY_COMMUNITIES_AND_DECIDED_TO_SIMPLIFY,
    label: 'community_survey.delete_community.motivation.option_5'
  },
  {
    value: MOTIVATION_VALUES.ANOTHER_MOTIVE,
    label: 'community_survey.delete_community.motivation.option_6'
  }
]
